module.exports = __webpack_public_path__ + "img/mint-stats.e7f64bba.png";